import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import { hasRoleRenter } from 'common/utility/userRoles';

import { createInitialValues, createFormValidationFn } from 'client/helpers/formikHelpers';

import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import ButtonDeprecated, { BUTTON_THEME_GREEN_ADOBE } from 'client/components/ButtonDeprecated';
import SrBox from 'client/components/SrBox';
import SrLink from 'client/components/SrLink/SrLink';
import SrErrorMessage, {
  SR_ERROR_MESSAGE_THEME_RED,
} from 'client/components/SrErrorMessage/SrErrorMessage';

import './SrUtilitySetupPage.less';

const getFormFields = () => {
  return [
    {
      id: 'phone',
      title: 'Phone',
      type: 'phone',
      properties: {
        placeholder: 'type your phone...',
      },
      validations: ['required', 'phone'],
    },
    {
      id: 'password',
      title: 'Password',
      type: 'password',
      properties: {
        placeholder: 'type your password...',
      },
      validations: ['required'],
    },
  ];
};

const SrUtilitySetupLoginErrorMessage = ({ error }) => {
  return (
    <SrBox marginTop="10px" borderRadius="3px">
      <SrErrorMessage theme={SR_ERROR_MESSAGE_THEME_RED}>{error.message}</SrErrorMessage>
    </SrBox>
  );
};

const SrUtilitySetupLogin = ({
  utilityUser,
  utilityPartner,
  utilityActivation,
  onSubmit,
  apiState,
}) => {
  const canContinueFlow = !utilityUser?.id || hasRoleRenter(utilityUser?.roles || []);

  const signupLink = utilityActivation
    ? `/utility-setup/${utilityPartner.slug}/signup/${utilityActivation.addressId}`
    : `/utility-setup/${utilityPartner.slug}`;

  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={createInitialValues({
        formFields: getFormFields(),
        defaultValues: {
          phone: '',
          password: '',
        },
      })}
      validate={(formValues) => {
        const formFields = getFormFields();
        return createFormValidationFn(formFields)(formValues);
      }}
      render={(formikBag) => {
        const formFields = getFormFields();

        return (
          <Form styleName="view">
            <div styleName="titleBox">
              <span>Login to see your utility info.</span>

              {utilityActivation?.user && (
                <span styleName="subTitle">
                  Use the phone ending in{' '}
                  {utilityActivation.user.phone.slice(-4)}.
                </span>
              )}
            </div>
            <div styleName="contentBox">
              <div styleName="cardBox">
                {formFields.map((field) => (
                  <SrFormikField
                    key={field.id}
                    formField={field}
                    formikBag={formikBag}
                    theme={SR_FIELD_THEME_ADOBE}
                    className="utilityProviderQuestion"
                  />
                ))}

                <SrBox margin="21px 0 0">
                  <ButtonDeprecated
                    type="submit"
                    theme={BUTTON_THEME_GREEN_ADOBE}
                    disabled={apiState?.inProgress || !canContinueFlow}
                    onClick={formikBag.handleSubmit}
                  >
                    Log In
                  </ButtonDeprecated>
                  {apiState?.error && (
                    <SrUtilitySetupLoginErrorMessage
                      error={apiState.error.error || apiState.error}
                      loginUrl={`/utility-setup/${utilityPartner.slug}/login`}
                    />
                  )}
                  {!canContinueFlow && (
                    <SrUtilitySetupLoginErrorMessage
                      error={{
                        message: 'Sorry, only renters can continue.',
                      }}
                    />
                  )}
                </SrBox>
                <SrBox textAlign="center" margin="20px 0 0">
                  <SrLink styleName="linkText" to={signupLink}>
                    Need an account? Sign up here →
                  </SrLink>
                  <br />
                  <br />
                  <SrLink
                    styleName="linkText"
                    to={`/utility-setup/${utilityPartner.slug}/reset-password`}
                  >
                    Forgot password? Reset here →
                  </SrLink>
                </SrBox>
              </div>
            </div>
          </Form>
        );
      }}
    />
  );
};

SrUtilitySetupLogin.propTypes = {
  utilityUser: PropTypes.object,
  utilityPartner: PropTypes.object,
  onSubmit: PropTypes.func,
  apiState: PropTypes.object,
};

SrUtilitySetupLogin.displayName = 'SrUtilitySetupLogin';

export default SrUtilitySetupLogin;
